import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: '¿Es difícil de seguir?',
    answer: 'No, está pensado para gente que trabaja y tiene poco tiempo. Las recetas son rápidas y los pasos son simples de incorporar a tu rutina diaria.'
  }, {
    question: '¿Tengo que comprar cosas raras?',
    answer: 'Para nada, usás lo que hay en cualquier mercado de barrio, Coto, Carrefour o el chino de la vuelta. Nada de ingredientes importados carísimos.'
  }, {
    question: '¿Voy a pasar hambre?',
    answer: 'No, el plan incluye proteínas y grasas buenas que dan saciedad real. No es una dieta restrictiva, es una limpieza estratégica.'
  }, {
    question: '¿Se paga por mes?',
    answer: 'No, es un pago único y el manual (con todos sus bonos) es tuyo para siempre. Lo descargás y te queda guardado.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white" data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-13">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-brown/70" data-id="element-14">
            Despejá tus dudas antes de empezar.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-15">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-sage/20 rounded-2xl overflow-hidden bg-cream/30" data-id="element-16">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-17">
                <span className="text-lg font-bold text-brown pr-4" data-id="element-18">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0 text-sage" data-id="element-19">
                  <ChevronDownIcon className="w-5 h-5" data-id="element-20" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-21">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-22">
                    <div className="px-6 pb-5 text-brown/80 text-lg leading-relaxed" data-id="element-23">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}